import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, IconButton } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useMainContext } from "../../../../../../context/useMainContext";

export default function BulkCheckModal({
  bulkCheckModalOpen,
  setBulkCheckModalOpen,
  handleBulkCheckConfirm,
  currentCheckType,
}) {
  const { selected } = useMainContext();

  return (
    <Dialog open={bulkCheckModalOpen} onClose={() => setBulkCheckModalOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle
        color="error"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        This action is billable
        <IconButton onClick={() => setBulkCheckModalOpen(false)} size="small" aria-label="Close dialog">
          <CloseOutlinedIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography>
          You are about to run a {currentCheckType} check on {selected.length} influencer
          {selected.length !== 1 ? "s" : ""}.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button
          variant="outlined"
          onClick={() => setBulkCheckModalOpen(false)}
          disableElevation
          aria-label="Cancel bulk check"
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleBulkCheckConfirm}
          aria-label="Proceed with bulk check"
          disableElevation
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}
